import { IconCheckCircleFilled } from '@iwoca/icons';
import { Spinner } from '@iwoca/orion';
import clsx from 'clsx';
import { CopyLinkOpenBankingEmailButton } from 'components/Signup/TradingHistory/RequirementTypes/BankStatements/CopyLinkOpenBankingEmailButton/CopyLinkOpenBankingEmailButton';
import linkOpenBankingStyles from 'components/Signup/TradingHistory/RequirementTypes/BankStatements/LinkOpenBanking/LinkOpenBanking.module.css';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { Link } from 'react-router-dom';
import styles from './LinkOpenBankingStatus.module.css';
import { useLinkOpenBankingStatus } from './useLinkOpenBankingStatus';

export const LinkOpenBankingStatus = () => {
  const { introducer } = useIntroducerData();
  const {
    linkedBankAccounts,
    isFetchingLinkedBankAccounts,
    customerEmail,
    customerFirstName,
  } = useLinkOpenBankingStatus();

  if (!introducer || !customerEmail || !customerFirstName) {
    return null;
  }

  const renderLinkedBankAccounts = () => {
    if (isFetchingLinkedBankAccounts) {
      return (
        <div data-testid="spinner" className={styles.spinner}>
          <Spinner />
        </div>
      );
    } else if (linkedBankAccounts.length === 0) {
      return (
        <div className={clsx(linkOpenBankingStyles.info, styles.info)}>
          <div className={linkOpenBankingStyles.details}>
            Link applicant's account(s) via Open Banking
            <ul>
              <li>We’ll write an email for you to send to your customer</li>
              <li>
                They’ll be able to link their bank account(s) in their iwoca
                account via{' '}
                <Link
                  target="_blank"
                  rel="noreferrer"
                  to="https://truelayer.com/reports/open-banking-guide/what-is-open-banking/"
                  className={styles.openBankingUrl}
                >
                  Open Banking
                </Link>
              </li>
              <li>
                iwoca will not contact them directly, except to send them a
                login link to their account
              </li>
            </ul>
            <p>
              Applicants that link Open Banking receive a decision{' '}
              <b>2x faster</b> than those who share PDF bank statements on
              average.
            </p>
          </div>

          <CopyLinkOpenBankingEmailButton
            secondary
            customerFirstName={customerFirstName}
            customerEmail={customerEmail}
            introducerFirstName={introducer.first_name}
          />
        </div>
      );
    }
    return (
      <div className={styles.linkedBankAccounts}>
        {linkedBankAccounts.map(({ bankName, accountNumberLastFourDigits }) => (
          <div
            className={styles.linkedBankAccount}
            key={accountNumberLastFourDigits}
          >
            <IconCheckCircleFilled fontSize="1.5rem" className={styles.icon} />
            <span>
              {bankName} account ending in {accountNumberLastFourDigits} linked
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      className={clsx(
        linkOpenBankingStyles.linkOpenBanking,
        styles.linkOpenBankingStatus,
      )}
    >
      <h3>Applicant's linked bank accounts</h3>
      {renderLinkedBankAccounts()}
    </div>
  );
};
